import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});


export async function submitTeamMember(memberData: {
  email: string;
  fullName: string;
  groupId: string;
  functionIds: string[];
  tenantId: string;
}) {
  try {
   

    const response = await authService.apiCall(`/team-invitations/invite`, {
      method: "POST",
    
      body: JSON.stringify(memberData)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Request failed with status ${response.status}: ${errorText}`);
    }

    const result = await response.json();
    return result;

  } catch (error:any) {
    console.error("Error submitting team member:", error.message);
    throw error;
  }
}

export async function viewInviteCatalog() {
  try {
   

    const response = await authService.apiCall(`/invite-catalog`, {
      method: "GET",
    
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to load invite catalog: ${response.status} - ${errorText}`);
    }

    const catalog = await response.json();
    return catalog;

  } catch (error:any) {
    console.error("Error fetching invite catalog:", error.message);
    throw error;
  }
}


// services/inviteService.ts

export interface InvitePayload {
  invitations: {
    email: string;
    fullName: string;
    groupId: string;
    functionIds: string[];
    tenantId: string;
  }[];
}

export async function sendBulkInvitations(payload: InvitePayload): Promise<void> {
  
  const response = await authService.apiCall('/team-invitations/invite/bulk', {
    method: 'POST',
  
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Failed to send invitations');
  }
}

export async function inviteBulk(invitations: {
  email: string;
  fullName: string;
  groupId: string;
  functionIds: string[];
  tenantId: string;
}[]): Promise<any> {
  try {

    const response = await authService.apiCall(`/team-invitations/invite/bulk`, {
      method: "POST",
    
      body: JSON.stringify({ invitations })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Request failed with status ${response.status}: ${errorText}`);
    }

    const result = await response.json();
    return result;

  } catch (error:any) {
    console.error("Error sending bulk invitations:", error.message);
    throw error;
  }
}

export async function getAllTeamInvitations(tenantId: string): Promise<any> {
  try {
   

    const response = await fetch(`${BASE_URL}/team-invitations?tenantId=${tenantId}`, {
      method: 'GET',
    
    });

    const data = await response.json();

    if (!response.ok) {
      const message = data?.message || `Error ${response.status}: Failed to fetch team invitations.`;
      throw new Error(message);
    }

    // Modified this part to handle different response structures
    if (Array.isArray(data)) {
      // If the response is directly the array of invitations
      return { success: true, data };
    } else if (data.data && Array.isArray(data.data)) {
      // If the response has a data property with the array
      return { success: true, data: data.data };
    } else if (data.success && Array.isArray(data.data)) {
      // If the response follows the success/data pattern
      return data;
    } else {
      throw new Error("Invalid response format from server");
    }
  } catch (error: any) {
    console.error("Failed to fetch team invitations:", error);
    throw new Error(error?.message || "Unexpected error occurred while fetching invitations.");
  }
}
export async function acceptTeamInvitation(tokenParam: string): Promise<any> {
  try {
 


    const response = await authService.apiCall(`/team-invitations/accept?token=${tokenParam}`, {
      method: "POST",
     
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to accept invitation.");
    }

    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Unexpected error during accept operation.");
  }
}



export async function resendTeamInvitation(invitationId: string): Promise<any> {
  try {
  

    const response = await authService.apiCall(`/team-invitations/resend/${invitationId}`, {
      method: "POST",
    
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to resend invitation");
    }

    if (!data.success) {
      throw new Error(data.message || "Server responded with failure");
    }

    return data;
  } catch (error) {
    console.error("Error resending invitation:", error);
    throw error;
  }
}

export async function deleteTeamInvitation(invitationId: string): Promise<any> {
  try {
  

   

    const response = await authService.apiCall(`/team-invitations/${invitationId}`, {
      method: "DELETE",
   
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to delete invitation");
    }

    if (!data.success) {
      throw new Error(data.message || "Server responded with failure");
    }

    return data;
  } catch (error) {
    console.error("Error deleting invitation:", error);
    throw error;
  }
}